import { Navigate } from 'react-router-dom';
import { useRefreshUserOnRouteChange } from '../hooks/useRefreshUserOnRouteChange';
import FlowLayoutShell from './FlowLayoutShell';

const BoardLayout = () => {
    const user = useRefreshUserOnRouteChange();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if ((user?.userTypeId !== "UTY1000006" && user?.userTypeId !== "UTY1000008") || (user?.boardResolution?.docUrl && !user?.boardResolution?.rejected)) {
        return <Navigate to="/onboarding" replace />;
    }

    return <FlowLayoutShell contentClassName="kyc-content" />;
};

export default BoardLayout;
